export default __webpack_public_path__ + "static/media/hero.51f390e7.jpg";